export const CREATE_PATIENT = "CREATE_PATIENT";
export const PATIENT_MESSAGE = "PATIENT_MESSAGE";